module.exports = __webpack_public_path__ + "img/bg-mfitt-top-img.7980e4df.jpg";